// extracted by mini-css-extract-plugin
export default {"tabNavigation":"viewReportV2_tabNavigation__YWesy","tabButton":"viewReportV2_tabButton__TVmDi","active":"viewReportV2_active__dnaJb"};